import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <p>© 2022 CareBNB</p>
      <p>Privacy · Terms · Sitemap · Company Details</p>
    </div>
  );
}

export default Footer;
